import React, { useState } from "react";
import { Helmet } from "react-helmet";
import Breadcrumb from "../../shared/breadcrumb/Breadcrumb";
import { useGetVideoGalleryQuery } from "../products/productSlice";
import { useTranslation } from "react-i18next";
function VideoGallery() {
  const { data, isLoading } = useGetVideoGalleryQuery();

  const { t } = useTranslation();
  const today = new Date();

  const date = today.getDate(); // Day of the month
  const month = today.getMonth() + 1; // Months are 0-indexed
  const year = today.getFullYear(); // Full year
  return (
    <>
      <Helmet>
        <title>Video Gallery | GGAS</title>
        <meta name="keyword" content="GGAS" />
        <meta name="description" content="GGAS" />
      </Helmet>
      <Breadcrumb title="Video Gallery" t={t} />
      <section className="videoGallery sectionPD">
        <div className="container">
          <div className="fisherman-content">
            <h6>GGAS</h6>
            <h3>Our Video Gallery</h3>
          </div>

          <div className="row">
            <div className="col-lg-4">
              <div className="videoFrame">
                <iframe
                  width={315}
                  height={300}
                  src="https://www.youtube.com/embed/BpAB2IQv-c0?autoplay=1&mute=1&loop=1&playlist=BpAB2IQv-c0"
                  title="Draper Expert Mechanic's Tool Kit - Ultimate Workshop & Mobile Engineer Set | Toolstation"
                  frameBorder={0}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                />
              </div>
            </div>
            <div className="col-lg-8">
              <div className="videoContent">
                <h4>India Aviation 2016 Hyderabad</h4>
                <p>
                  GGAS Maintenance Tooling &amp; Equipments Services
                  participated in India Aviation 2016 held in Hyderabad.
                </p>
                <ul>
                  <li>
                    <strong>Release Date - </strong> {date} / {month} / {year}
                  </li>
                  <li>
                    <strong>Type - </strong> NaN
                  </li>

                  <li>
                    <strong>Model - </strong> NaN
                  </li>
                  <li>
                    <strong>Pack -</strong> NaN
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default VideoGallery;
